import { XPay as XPayDevelopment } from "@xstak/xpay-element-stage-v2";
import { XPay as XPayProduction } from "@xstak/xpay-element-live-v2";
import { Payment } from "src/pages/PaymentForReservation";


export default function PaymentMethods({ total,selectedSlot,occasion,specialRequest }) {
  const XPay = process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === "staging" ? XPayProduction : XPayDevelopment;
  return (
    <>
      <XPay
        xpay={{
          publishableKey: process.env.REACT_APP_XPAY_PUBLISHABLE_KEY,
          accountId: process.env.REACT_APP_XPAY_ACCOUNT_ID,
          hmacSecret: process.env.REACT_APP_XPAY_HMAC_SECRET,
        }}
      >
        <Payment
          total={total}
          selectedSlot={selectedSlot}
          occasion={occasion}
          specialRequest={specialRequest}
        />
      </XPay>
    </>
  );
}

